<div class="app-container">
  <page-header [icon]="'fa-hands-usd'" [title]="'priceLevels.title'">
    <ng-container class="header-button">
      <btn
        [routerLink]="['/price-level']"
        [icon]="'far-plus'"
        [label]="'priceLevel.create'"
        [title]="'priceLevel.create' | translate"
        [classes]="['btn-first', 'float-right']"
        [dataCyAttribute]="'create-price-group'"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <!--    todo filters()-->
    <!--    todo filters()ForExport-->
    <app-filter-form
      (onSubmit)="queryPriceLevels.refetch()"
      (onClearClick)="clearFilters()"
      [entity]="'price-levels'"
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [isFilterInvisible]="true"
      [totalItems]="totalItems()"
    >
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3">
          <form-row-input
            [model]="filters().name"
            (modelChange)="onNameFilterChange($event)"
            [icon]="null"
            [label]="'priceLevel.name'"
            (keydown.enter)="queryPriceLevels.refetch()"
            [dataCyAttribute]="'price-level-name-filter'"
          ></form-row-input>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <form-row-select
            [(model)]="filters().isPercentage"
            [icon]="null"
            [label]="'priceLevel.isPercentage'"
            [options]="booleanFilterOptions"
            [dataCyAttribute]="'isPercentage-filter'"
          ></form-row-select>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <form-row-select
            [(model)]="filters().withVat"
            [icon]="null"
            [label]="'priceLevel.withVat'"
            [options]="booleanFilterOptions"
            [dataCyAttribute]="'withVat-filter'"
          ></form-row-select>
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <form-row-select
            [options]="currenciesOptions()"
            [icon]="null"
            [label]="'priceLevel.currency'"
            [(model)]="filters().currency"
            [dataCyAttribute]="'currency-filter'"
          ></form-row-select>
        </div>
      </div>
    </app-filter-form>

    <app-base-listing
      [listName]="'priceLevels'"
      [query]="queryPriceLevels"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
